import { render, staticRenderFns } from "./portrayal.vue?vue&type=template&id=329fefe0&"
import script from "./portrayal.vue?vue&type=script&lang=js&"
export * from "./portrayal.vue?vue&type=script&lang=js&"
import style0 from "./portrayal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports